import { connect } from 'react-redux'
import { setWizards } from 'core/components/wizard/actions'
import { setTradeIn } from '../actions'
import VehicleConfirm from './VehicleConfirm'

const mapStateToProps = state => ({
  wizards: state.wizards,
  tradeIn: state.tradeIn,
  configuration: state.configuration,
  carInformations: state.carInformations
})

const mapDispatchToProps = {
  setWizards,
  setTradeIn
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleConfirm)
